<template>
  <div>
    <div v-bind:class="{'col-12': !$parent.meeting_view }">
      <div class="card">
        <div class="card-body">
          <div class="d-flex">
            <div>
              <h4 class="card-title text-muted">{{ $t("My KBI's") }}</h4>
              <h3 class="font-bold">{{ selectedKBI.title }}</h3>
            </div>
            <div class="ml-auto">
              <button type="button" class="btn text-info bg-netral dropdown-toggle p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="icon-settings"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <a v-for="(kbi, key) in kbiData" class="dropdown-item" @click="selectKBI(key)">{{ kbi.title }}</a>
              </div>
            </div>
          </div>
          <div>
            <div class="text-left">

              <div class="">
                <span class="text-big text-muted">{{ selectedKBI.performance }}</span>
                <span v-if="selectedKBI.performance_unit !== selectedKBI.total_unit" class="text-muted">{{ selectedKBI.performance_unit }}</span>
                <span class="text-muted">/</span>
                <span>{{ selectedKBI.total }}</span>
                <span>{{ selectedKBI.total_unit }}</span>
                <br>
                <h6 class="text-muted">{{ $t('last week') }}</h6>
              </div>
            </div>

            <div class="progress m-t-15 m-b-15">

              <div class="progress-bar bg-muted" role="progressbar" :style="{getPercentage}" style="height: 6px;" aria-valuemin="0" aria-valuemax="100"></div>
            </div>

            <span class="text-info d-none d-sm-block"><a class="overrule" @click="toggleModal"><i class="ti-plus"></i> {{ $t("Details") }}</a></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <transition v-if="modal" name="modal">
      <div class="modal-mask" @click="toggleModal" >
        <div class="modal-wrapper">
          <div class="modal-dialog" @click.stop style="overflow-y: initial !important; max-width: 60% !important">
            <div class="modal-content">

              <!-- HEADER -->
              <div class="modal-header">
                <h3 class="modal-title"><span class="text-muted">{{ $t("KBI") }}</span> {{ $t("KBI's for") }} {{ username }}</h3>

                <div class="pull-right">
                  {{ $t("Person") }}
                  <select v-model="selectedPerson" class="custom-select b-0 btn-sm f14 btn-rounded btn-outline-secondary bg-inverse custom-select text-neutral">
                    <option v-for="person in descendants" :value="person.uid" @click="getKbiData(false)">{{ person.firstname }} {{ person.lastname }}</option>
                  </select>

                  {{ $t("period") }}
                  <date-range-picker @update="select_dates" :start-date="startDate" :end-date="endDate" opens="center"></date-range-picker>

                  <button type="button" class="close p-l-20 p-t-5 text-info overrule" @click="modal = false"><i class="ti-close"></i></button>
                </div>
              </div>

              <!-- BODY -->
              <div class="modal-body" style="overflow-y: auto">
                <div class="col-lg-12 col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="table-responsive m-t-20">
                        <table id="tableActions" class="table table-bordered table-striped">

                          <thead>
                          <tr>
                            <th>{{ $t("KBI") }}</th>
                            <th>{{ $t("Performance") }}</th>
                            <th>{{ $t("Total") }}</th>
                            <th>{{ $t("Ratio") }}</th>
                          </tr>
                          </thead>

                          <tbody>
                          <tr v-for="kbi in kbis">
                            <td>{{ kbi.title }}</td>
                            <td>{{ kbi.performance }} {{ kbi.performance_unit}}</td>
                            <td>{{ kbi.total }} {{ kbi.total_unit }}</td>
                            <td>{{ kbi.ratio }}</td>
                          </tr>

                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import apiHelper from '../mixins/APIHelper';

  export default {
    props: {
      "data_kbi": {
        default: null,
        type: Object
      }
    },
    name: "kbiWidget",
    data: function () {
      return {
        kbiData: JSON.parse(JSON.stringify(this.data_kbi)),
        kbis: JSON.parse(JSON.stringify(this.data_kbi)),
        selectedKBI: [],
        userData: Object,
        modal: false,
        descendants: Object,
        selectedPerson: localStorage.getItem('user_uid'),
        startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      }
    },
    created() {
      this.userData = apiHelper.getUserData();
      if (this.kbiData === null) {
        this.getKbiData(true);
      }
      this.getSelectedKBI("");
      this.getDesc();
    },
    methods: {
      // Method to grab the KBI data
      getKbiData: function (both) {
        let vm = this;
        let data_to_send = {
          "date_start": moment(vm.startDate).format('YYYY-MM-DD'),
          "date_end" : moment(vm.endDate).format('YYYY-MM-DD')
        };

        apiHelper.getResource("/api/user/" + vm.selectedPerson + "/kbi", data_to_send).then((data) => {
          if (both) {
            vm.kbiData = data;
            vm.kbis = data;
          } else {
            vm.kbis = data;
          }
        });
      },

      // Selecteds the KBI to be displayed
      // kbiData HAS TO HAVE ALL KBI'S in it
      getSelectedKBI: function (value_sel) {
        let vm = this;

        if (value_sel !== "") {
          vm.selectedKBI = vm.kbiData[value_sel];
          delete vm.kbiData[value_sel];
        } else if (vm.selectedKBI.length === 0) {
          let settings = vm.userData["Settings"]["data"];

          for (let i = 0; i < settings.length; i++) {
            if (settings[i]["setting"] === 'dashboard-kbi') {
              let value = settings[i]["value"];
              vm.selectedKBI = vm.kbiData[value];

              if (typeof vm.selectedKBI === "undefined"){
                let value = Object.keys(vm.kbiData)[0];
                vm.selectedKBI = vm.kbiData[value];
              }
              delete vm.kbiData[value];
            }
          }
        } else {
          let value = Object.keys(vm.kbiData)[0];
          vm.selectedKBI = vm.kbiData[value];

          delete vm.kbiData[value];
        }
      },

      // Shows the modal
      toggleModal: function () {
        this.modal = !this.modal;
      },

      // Selects a new KBI
      selectKBI: function(title) {
        let vm = this;
        vm.kbiData = JSON.parse(JSON.stringify(this.data_kbi));
        vm.getSelectedKBI(title);
        let data = {
          "value": title
        };

        apiHelper.putResource("/api/user/{uid}/settings/dashboard-kbi", data).then((data) => {
          if (Object.keys(data).length > 0) {
            vm.userData.Settings.data[0].value = data.value;
            apiHelper.setUserData(vm.userData);
            vm.userData = apiHelper.getUserData();
          } else {
            vm.$notify({
              group: "notification",
              title: vm.$t("Error"),
              text: vm.$t("Something went wrong please try again."),
              type: 'error'
            });
          }
        });
      },

      // Grabs the descendants of the current user
      getDesc: function () {
        let vm = this;

        apiHelper.getResource("/api/user/{uid}/descendants").then((data) => {
          vm.descendants = data;
        })
      },

      select_dates: function (response) {
        if (response !== null) {
          this.startDate = response.startDate;
          this.endDate = response.endDate;
          this.getKbiData(false);
        }
      }
    },
    computed: {
      getPercentage: function () {
        let vm = this;
        if (vm.selectedKBI.length > 0) {
          let percentage = vm.selectedKBI['ratio'].split(" ", 1);
          return percentage[0];
        }
      },

      username: function () {
        let vm = this;
        if (vm.selectedPerson !== localStorage.getItem('user_uid')) {
          for (let u in vm.descendants) {
            if (vm.descendants[u].uid === vm.selectedPerson) {
              return vm.descendants[u].firstname + ' ' + vm.descendants[u].lastname;
            }
          }
        } else {
          return vm.userData.firstname + ' ' + vm.userData.lastname;
        }
      }
    },
    // So that if we press esc the modal closes
    mounted: function () {
      let vm = this;
      document.addEventListener("keydown", (event) => {
        if (event.key === 'Escape') {
          vm.modal = false;
          vm.modal = false;
        }
      });
    },
    watch: {
      selectedPerson: function (value) {
        this.getKbiData(false);
      }
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    /*display: table-cell;*/
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/KBIWidget.vue